import { FC } from 'react'
import { noop } from 'lodash'

import { TRepost } from '../types'
import RepostButton from '../RepostButton'
import MobileBottomModal from '../../../../../mobile/MobileBottomModal'
import { getUndoRepostProps } from '../helpers'
import RepostAction from '../RepostAction'
import QuoteAction from '../QuoteAction'

const itemClass =
  'text-base flex font-medium flex-row gap-xxs text-gray-900 p-xxs'

const RepostModal: FC<TRepost> = (props) => {
  const { canRepost, isFeedAuthor, onQuote, onRepost, readonly } = props
  const { isDisabledRepost, isActiveUndoRepost } = getUndoRepostProps(props)
  return (
    <MobileBottomModal
      className="!p-xxs"
      childrenClassName="!p-none"
      renderContent={() => (
        <div className="gap-xxxs flex flex-col">
          <div
            className={itemClass}
            onClick={isDisabledRepost ? noop : onRepost}
          >
            <RepostAction
              isFeedAuthor={isFeedAuthor}
              isDisabledRepost={isDisabledRepost}
              isActiveUndoRepost={isActiveUndoRepost}
            />
          </div>
          <div className={itemClass} onClick={canRepost ? onQuote : noop}>
            <QuoteAction canRepost={canRepost} />
          </div>
        </div>
      )}
      renderToggler={(toggler) => (
        <div className="flex items-center" onClick={readonly ? noop : toggler}>
          <RepostButton {...props} isDisabled={!canRepost} />
        </div>
      )}
    />
  )
}

export default RepostModal
